import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('settings', ['settings']),

    stateCompletedBookingsDefaultDateRange: {
      get () {
        return this.settings.completed_bookings_default_date_range
      },

      set (value) {
        this.setSettingsProperty({ property: 'completed_bookings_default_date_range', value })
      }
    },

    stateCommissionRate: {
      get () {
        return this.settings.commission_rate
      },

      set (value) {
        this.setSettingsProperty({ property: 'commission_rate', value })
      }
    },

    stateDepositPayment: {
      get () {
        return this.settings.deposit_payment
      },

      set (value) {
        this.setSettingsProperty({ property: 'deposit_payment', value })
      }
    },

    statePrivacyLink: {
      get () {
        return this.settings.privacy_link
      },

      set (value) {
        this.setSettingsProperty({ property: 'privacy_link', value })
      }
    },

    stateTncLink: {
      get () {
        return this.settings.tnc_link
      },

      set (value) {
        this.setSettingsProperty({ property: 'tnc_link', value })
      }
    },

    stateCollectionStatementLink: {
      get () {
        return this.settings.collection_statement
      },

      set (value) {
        this.setSettingsProperty({ property: 'collection_statement', value })
      }
    },

    stateNotificationEmail: {
      get () {
        return this.settings.notification_email
      },

      set (value) {
        this.setSettingsProperty({ property: 'notification_email', value })
      }
    },

    stateNotificationPhone: {
      get () {
        return this.settings.notification_phone
      },

      set (value) {
        this.setSettingsProperty({ property: 'notification_phone', value })
      }
    },

    stateInvoiceTemplate: {
      get () {
        return this.settings.talent_invoice_template
      },

      set (value) {
        this.setSettingsProperty({ property: 'talent_invoice_template', value })
      }
    },

    stateBillboardPostLength: {
      get () {
        return this.settings.billboard_post_length
      },

      set (value) {
        this.setSettingsProperty({ property: 'billboard_post_length', value })
      }
    },

    stateDepositPaymentWarningAdmin: {
      get () {
        return this.settings.deposit_payment_warning_admin
      },

      set (value) {
        this.setSettingsProperty({ property: 'deposit_payment_warning_admin', value })
      }
    },

    stateDepositPaymentWarningClient: {
      get () {
        return this.settings.deposit_payment_warning_client
      },

      set (value) {
        this.setSettingsProperty({ property: 'deposit_payment_warning_client', value })
      }
    },

    stateFinalPaymentWarningAdmin: {
      get () {
        return this.settings.final_payment_warning_admin
      },

      set (value) {
        this.setSettingsProperty({ property: 'final_payment_warning_admin', value })
      }
    },

    stateFinalPaymentWarningClient: {
      get () {
        return this.settings.final_payment_warning_client
      },

      set (value) {
        this.setSettingsProperty({ property: 'final_payment_warning_client', value })
      }
    },

    stateInitialTalentReminder: {
      get () {
        return this.settings.initial_talent_reminder
      },

      set (value) {
        this.setSettingsProperty({ property: 'initial_talent_reminder', value })
      }
    },

    stateSecondTalentReminder: {
      get () {
        return this.settings.second_talent_reminder
      },

      set (value) {
        this.setSettingsProperty({ property: 'second_talent_reminder', value })
      }
    },

    stateFinalTalentReminder: {
      get () {
        return this.settings.final_talent_reminder
      },

      set (value) {
        this.setSettingsProperty({ property: 'final_talent_reminder', value })
      }
    },

    stateIosMinimumVersion: {
      get () {
        return this.settings.ios_minimum_version
      },

      set (value) {
        this.setSettingsProperty({ property: 'ios_minimum_version', value })
      }
    },

    stateAndroidMinimumVersion: {
      get () {
        return this.settings.android_minimum_version
      },

      set (value) {
        this.setSettingsProperty({ property: 'android_minimum_version', value })
      }
    },

    stateAppMinimumVersion: {
      get () {
        return this.settings.app_minimum_version
      },

      set (value) {
        this.setSettingsProperty({ property: 'app_minimum_version', value })
      }
    }
  },

  methods: {
    ...mapActions('settings', ['setSettingsProperty'])
  }
}
